
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M100 24c7.732 0 14 6.268 14 14l-.001 49H163c7.732 0 14 6.268 14 14s-6.268 14-14 14h-49.001l.001 49c0 7.732-6.268 14-14 14s-14-6.268-14-14l-.001-49.001L37 115c-7.732 0-14-6.268-14-14s6.268-14 14-14l48.999-.001L86 38c0-7.732 6.268-14 14-14z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    